import { MessageIcon } from '../NotificationBell/MessageIcon';
import { NotificationBell } from '../NotificationBell/NotificationBell';
import { ProfileIcon } from '../NotificationBell/ProfileIcon';
import './cabinet-sidebar.css';

export interface SidebarItem<T extends string = string> {
  screen: T;
  label: string;
  icon: string;
}

export interface SidebarGroup<T extends string = string> {
  title?: string;
  items: SidebarItem<T>[];
}

export interface CabinetSidebarProps<T extends string = string> {
  groups: SidebarGroup<T>[];
  activeScreen?: string;
  activeLabel?: string;
  onNavigate: (screen: T) => void;
  className?: string;
  unreadMessages?: number;
  unreadNotifications?: number;
}

function renderSidebarIcon(icon: string, hasUnread = false) {
  if (icon.includes('bell')) {
    return <NotificationBell hasUnread={hasUnread} size={24} />;
  }
  if (icon.includes('messages') || icon.includes('chat')) {
    return <MessageIcon hasUnread={hasUnread} size={24} />;
  }
  if (icon.includes('profile')) {
    return <ProfileIcon size={24} />;
  }
  return <img src={`/figma/assets/${icon}`} alt="" aria-hidden="true" />;
}

export function CabinetSidebar<T extends string = string>({
  groups,
  activeScreen,
  activeLabel,
  onNavigate,
  className = '',
  unreadMessages = 0,
  unreadNotifications = 0,
}: CabinetSidebarProps<T>) {
  return (
    <aside className={`cabinet-sidebar ${className}`.trim()} data-figma-node="2671:37562">
      {groups.map((group, groupIndex) => (
        <div className="cabinet-sidebar__group" key={group.title ?? `group-${groupIndex}`}>
          {group.title && <strong>{group.title}</strong>}
          <nav aria-label={group.title ?? 'Навигация'}>
            {group.items.map((item) => {
              const isActive = activeLabel
                ? item.label === activeLabel
                : item.screen === activeScreen;
              const count = item.icon.includes('messages') || item.icon.includes('chat')
                ? unreadMessages
                : item.icon.includes('bell') ? unreadNotifications : 0;
              return (
                <a
                  href={`#${item.screen}`}
                  className={isActive ? 'is-active' : ''}
                  key={`${item.screen}-${item.label}`}
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate(item.screen);
                  }}
                >
                  <span className="cabinet-sidebar__icon" aria-hidden="true">
                    {renderSidebarIcon(item.icon, count > 0)}
                  </span>
                  <span>{item.label}</span>
                  {count > 0 ? <span className="cabinet-sidebar__count">{count > 99 ? '99+' : count}</span> : null}
                </a>
              );
            })}
          </nav>
        </div>
      ))}
    </aside>
  );
}
